// generated file, if you want to edit this file manually change the word "generated" to "manual"
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
import MaterialToolbar from "@material-ui/core/Toolbar";
import { excludeKeys } from "./../utils";
const useStylesForToolBar = makeThemedStyles("QPRAppBar.ToolBar", (theme) => ({
  ToolBar: {},
}));
type PropType = React.ComponentProps<typeof MaterialToolbar>;
export const ToolBar: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForToolBar();
  const enabledClasses = excludeKeys(styles, ["ToolBar"]);
  /* eslint-disable */
  return (
    <MaterialToolbar
      {...props}
      classes={{
        root: styles.ToolBar,
        ...enabledClasses,
      }}
      className={clsx(styles.ToolBar)}
    >
      {props?.children}
    </MaterialToolbar>
  );
};
export default ToolBar;
